/**
 * Office.context.ui.displayDialogAsync dimension configurations.
 * Heights and widths are percentages of the screen, not pixels.
 */

export const DIALOG_SIZES = {
  /** Small notifications (success/error confirmations) */
  SMALL: { height: 200, width: 300 },
  /** Medium dialogs (error details, raw data display) */
  MEDIUM: { height: 250, width: 350 },
  /** Large dialogs (complex confirmations, multi-action) */
  LARGE: { height: 300, width: 400 },
  /** Login dialog (uses iframe: false for redirect-based auth) */
  LOGIN: { height: 60, width: 40, displayInIframe: false },
  /** Templates list dialog */
  TEMPLATES: { height: 160, width: 320 },
} as const;
